module.exports = "<div class=\"ctx-table-tree-content\">\n    <div class=\"table-tree-view\"\n         ctx-table-treeview=\"ctxTableTree.elements\"\n         ivh-treeview-options=\"ctxTableTree.customOpts\"></div>\n    <div class=\"horizontal-tree-scroller\" id=\"horizontal-tree-scroller\" ctx-custom-scroll-bar scroll-el=\"ctxTableTree.scrollEl\" while-scrolling-fn=\"ctxTableTree.whileScrollingFn(draggerLeft)\">\n        <div class=\"inside-tree-scroller\" id=\"inside-horizontal\"></div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxTableTree/ctxTableTree.template.html
// module id = 115
// module chunks = 0 1